"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.toggleIssueSubscriptionArgsValidator = exports.toggleIssueSubscriptionArgsSchema = exports.markIssueAsViewedArgsValidator = exports.markIssueAsViewedArgsSchema = exports.setAcceptedAnswerArgsValidator = exports.setAcceptedAnswerArgsSchema = exports.updateIssueArgsSchema = exports.createIssueTeaserData = exports.createIssueFromArgs = exports.createIssueArgsValidator = exports.createIssueArgsSchema = exports.MAX_ISSUE_BODY_LENGTH = exports.MAX_ISSUE_TITLE_LENGTH = exports.imageMarkerPropsSchema = exports.pdfMarkerPropsSchema = exports.markerPositionSchema = exports.textSelectionPropsSchema = void 0;
var channel_1 = require("../channel");
var suretype_1 = require("suretype");
var common_1 = require("../../../common");
exports.textSelectionPropsSchema = suretype_1.v.object({
    startOffset: suretype_1.v.number().required(),
    endOffset: suretype_1.v.number().required(),
    hash: suretype_1.v.number().required()
});
exports.markerPositionSchema = suretype_1.v.object({
    top: suretype_1.v.number().required(),
    left: suretype_1.v.number().required()
});
exports.pdfMarkerPropsSchema = suretype_1.v.object({
    position: exports.markerPositionSchema.required(),
    pageIndex: suretype_1.v.number().required()
});
exports.imageMarkerPropsSchema = suretype_1.v.object({
    position: exports.markerPositionSchema.required(),
    hash: suretype_1.v.number().required(),
});
// --------------------------
// constants
// --------------------------
exports.MAX_ISSUE_TITLE_LENGTH = 200;
exports.MAX_ISSUE_BODY_LENGTH = 4000;
// --------------------------
// create
// --------------------------
exports.createIssueArgsSchema = suretype_1.v.object({
    // cmd: v.string().const("createIssue").required(),
    channel: channel_1.channelReferenceInfoSchemaSureType.required(),
    issueId: common_1.idSchema.required(),
    link: suretype_1.v.anyOf([exports.textSelectionPropsSchema, exports.pdfMarkerPropsSchema, exports.imageMarkerPropsSchema]).required(),
    title: suretype_1.v.string().maxLength(exports.MAX_ISSUE_TITLE_LENGTH).required(),
    body: suretype_1.v.string().maxLength(exports.MAX_ISSUE_BODY_LENGTH).required(),
    category: suretype_1.v.string().enum("Question", "Error", "Opinion", "Suggestion", "Info").required(),
    anonymous: suretype_1.v.boolean().required(),
    global: suretype_1.v.boolean().required()
});
exports.createIssueArgsValidator = (0, suretype_1.compile)(exports.createIssueArgsSchema);
function createIssueFromArgs(user, args) {
    var _a;
    return {
        authorId: user.id,
        details: __assign(__assign(__assign({}, (!args.anonymous && user.name) && {
            authorName: user.name
        }), (args.global) && {
            communityId: args.channel.communityId
        }), { title: args.title, body: args.body, link: args.link, acceptedAnswerId: null, 
            // commitId: args.issueId,
            // contributors: [],
            subscribers: (_a = {},
                _a[args.channel.communityId] = [user.id],
                _a), counters: {
                answers: 0,
                comments: 0,
                proposals: 0
            } }),
        // filter
        hasAcceptedAnswer: false,
        category: args.category,
        // sort
        createdOn: (new Date()).getTime(),
        counters: {
            usersReached: 1,
            upVotes: 0
        }
    };
}
exports.createIssueFromArgs = createIssueFromArgs;
function createIssueTeaserData(id, issue) {
    return {
        id: id,
        link: issue.details.link,
        title: issue.details.title,
        hasAcceptedAnswer: issue.hasAcceptedAnswer,
        category: issue.category
    };
}
exports.createIssueTeaserData = createIssueTeaserData;
// --------------------------
// update
// --------------------------
exports.updateIssueArgsSchema = suretype_1.v.object({
    collection: suretype_1.v.string().const("issues").required(),
    update: suretype_1.v.object({
        title: suretype_1.v.string().maxLength(exports.MAX_ISSUE_TITLE_LENGTH).required(),
        body: suretype_1.v.string().maxLength(exports.MAX_ISSUE_BODY_LENGTH).required()
    }).required()
});
// --------------------------
// setAcceptedAnswer
// --------------------------
exports.setAcceptedAnswerArgsSchema = suretype_1.v.object({
    // cmd: v.string().const("setAcceptedAnswer").required(),
    channel: channel_1.channelReferenceInfoSchemaSureType.required(),
    issueId: common_1.idSchema.required(),
    answerId: suretype_1.v.anyOf([common_1.idSchema, suretype_1.v.null()]).required(),
    global: suretype_1.v.boolean().required()
});
exports.setAcceptedAnswerArgsValidator = (0, suretype_1.compile)(exports.setAcceptedAnswerArgsSchema);
// --------------------------
// markIssueAsViewed
// --------------------------
exports.markIssueAsViewedArgsSchema = suretype_1.v.object({
    // cmd: v.string().const("markIssueAsViewed").required(),
    channel: channel_1.channelReferenceInfoSchemaSureType.required(),
    issueId: common_1.idSchema.required(),
    global: suretype_1.v.boolean().required()
});
exports.markIssueAsViewedArgsValidator = (0, suretype_1.compile)(exports.markIssueAsViewedArgsSchema);
// --------------------------
// (un-)subscribe to issue
// --------------------------
exports.toggleIssueSubscriptionArgsSchema = suretype_1.v.object({
    // cmd: v.string().const("toggleIssueSubscription").required(),
    issueRef: suretype_1.v.object({
        // cmd: v.string().const("markIssueAsViewed").required(),
        channel: channel_1.channelReferenceInfoSchemaSureType.required(),
        issueId: common_1.idSchema.required()
    }).required(),
    value: suretype_1.v.boolean().required(),
    global: suretype_1.v.boolean().required()
});
exports.toggleIssueSubscriptionArgsValidator = (0, suretype_1.compile)(exports.toggleIssueSubscriptionArgsSchema);
